
const formatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
var moment = require('moment');

const roomhelpers = {
    toCurrency(value) {
        return formatter.format(value)
    },
    mipmap: function mipmap(src, res) {
        if (src) {
            if (src.includes('https://media.xmlcal.com')){ 
                var imgblocks = src.split("/");
                var imgfile = imgblocks[imgblocks.length - 1];
                var thumbnailimgsmall = imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
                imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
                return imgblocks.join("/");
            } else {
                return src;
            }
        } else {
            return 0;
        }
    },
    getRoomImage(room_id) {
        try {
            JSON.parse(this.prop[JSON.parse(this.rooms)[room_id].propID].images).hosted.find(x => x.map[0].position == 0);
        } catch (e) {
            return 0;
        }
    },
    readable: function (string) {
        var s = string.split("_").join(" ").toLowerCase();
        return s && s[0].toUpperCase() + s.slice(1);
    },
    frequencies(values, binsize) {
        var mapped = values.map(function (val) {
            return Math.ceil(val / binsize);
        });
        return mapped.reduce(function (freqs, val, i) {
            var bin = (binsize * val);
            freqs[bin] = freqs[bin] ? freqs[bin] + 1 : 1;
            return freqs;
        }, {});
    },
    getUpsellNameWithoutMax(name) {
        return name.split("(max:")[0]
    },
    getUpsellTotalPrice(upsell, roomID) {
        var price = upsell.price;
        upsell.period == 1 ? price *= this.nrDays : upsell.period == 2 ? price *= (this.nrDays % 7) : upsell.period == 4 ? price *= (this.nrDays + 1) : null;
        upsell.type == 3 ? price *= upsell.amount : null;
        // var blocks = JSON.parse(this.setup.split(".")).find(element => element.split("_")[0] == roomID).split("_")
        if (upsell.unit != 0 && this.setup) {
            if (upsell.unit == 4) {
                price *= blocks[1]
            } else {
                var roomInfo = blocks[2].split("-");
                var numAdult = 0;
                var numChildren = 0;
                roomInfo.forEach(item => {
                    numAdult += parseInt(item.split(",")[0])
                    numChildren += parseInt(item.split(",")[1])
                });
                upsell.unit == 1 ? price *= numAdult + numChildren : upsell.unit == 2 ? price *= numAdult : upsell.unit == 3 ? price *= numChildren : null;
            }
        }
        return price;
    },
    getRoomNames(setup) {
        var roomNames = []
        for (var block of JSON.parse(setup)) {

            for (let item = 0; item < parseInt(block.split("_")[1]); item++) {
                roomNames.push({
                    "id": JSON.parse(this.rooms)[block.split("_")[0]].id,
                    "name": JSON.parse(this.rooms)[block.split("_")[0]].name,
                    "adult": block.split("_")[2].split("-")[item].split(',')[0],
                    "child": block.split("_")[2].split("-")[item].split(',')[1],
                    "property": this.prop[JSON.parse(this.rooms)[JSON.parse(this.rooms)[block.split("_")[0]].id].propID].name
                })
            }
        }
        return roomNames
    },
    getOccurrence(array, value) {
        return array.filter((v) => (v === parseInt(value))).length;
    },
    isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    },
    formatDate(dateString) {
        return moment(dateString, 'YYYY-MM-DD').locale(this.$i18n.locale).format('ddd Do MMM');
    },
    getAmountOfRooms(setup) {
        var amount = 0;
        JSON.parse(setup).forEach((item) => {
            amount += parseInt(item.split("_")[1])
        })
        return amount;
    },
    getLocation: function (string) {
        var features = string;
        var returnFeatures = new Array();
        var locations = [
            "BEACH",
            "BEACH_FRONT",
            "BEACH_VIEW",
            "GOLF_COURSE_FRONT",
            "GOLF_COURSE_VIEW",
            "LAKE",
            "LAKE_FRONT",
            "LAKE_VIEW",
            "MONUMENT_VIEW",
            "MOUNTAIN",
            "MOUNTAIN_VIEW",
            "NEAR_OCEAN",
            "OCEAN_FRONT",
            "OCEAN_VIEW",
            "RESORT",
            "RIVER",
            "RURAL",
            "SKI_IN",
            "SKI_OUT",
            "VILLAGE",
            "WATER_VIEW",
            "WATER_FRONT",
        ];
        for (var index in locations) {
            if (features.includes(locations[index])) {
                return locations[index].split("_").join(" ").charAt(0) + locations[index].split("_").join(" ").slice(1).toLowerCase()
            }
        }
        return 0;
    },
    getBedrooms: function (string) {
        var features = JSON.parse(string);
        var returnFeatures = new Array();
        for (var index in features) {
            if (features[index].length > 1 && features[index].includes("BEDROOM")) {
                returnFeatures.push(features[index]);
            }
        }
        if (returnFeatures.length == 1) {
            return returnFeatures.length + " bedroom";
        } else if (returnFeatures.length > 1) {
            return returnFeatures.length + " bedrooms";
        } else {
            return 0;
        }
    },
    getsubUSPFeatures: function (string) {
        var features = JSON.parse(string);
        const usps = [
            "FIREPLACE",
            "PRIVATE_YARD",
            "VIDEO_ON_DEMAND",
            "TV",
            "ROOM_SERVICE",
            "PARKING_INCLUDED",
            "PETS_CONSIDERED",
            "WHEELCHAIR_YES",
            "CLOSETS_IN_ROOM",
            "LUXORY_LINEN",
            "REFRIGERATOR",
            "DESK",
            "MICROWAVE",
            "WASHER",
            "DRYER",
            "TABLES_AND_CHAIRS"
        ];
        var returnFeatures = new Array();
        for (var index in features) {
            if (features[index].length == 1 && usps.includes(features[index][0])) {
                returnFeatures.push(features[index]);
            }
        }
        return returnFeatures;
    },
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    //This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
    getPropDistance() {
        if (this.selectedRooms) {
            var maxDistance = 0;

            var useProp = []

            for (var room of this.selectedRooms) {
                useProp.push(JSON.parse(this.properties)[JSON.parse(this.rooms)[room]['propID']])
            }

            for (var index1 in useProp) {
                for (var index2 in useProp) {
                    var R = 6371; // km
                    var dLat = this.toRad(Number(useProp[index1].latitude) - Number(useProp[index2].latitude));
                    var dLon = this.toRad(Number(useProp[index1].longitude) - Number(useProp[index2].longitude));
                    var lat1 = this.toRad(Number(useProp[index1].latitude));
                    var lat2 = this.toRad(Number(useProp[index2].latitude));

                    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
                    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    var d = R * c;
                    if (d > maxDistance) {
                        maxDistance = d;
                    }
                }
            }
            return maxDistance;
        }
    },
    toRad(Value) {
        return Value * Math.PI / 180;
    },
    getBothFeatures(item) {
        return [item.features, this.props[item.propID].features]
    },
    getBedroomInfo: function (string) {
        var features = JSON.parse(string);
        var bedrooms = new Array();
        for (var index in features) {
            if (features[index].length > 1 && features[index].includes("BEDROOM")) {
                bedrooms.push(features[index]);
            }
        }
        var returnArray = new Array();
        for (var index in bedrooms) {
            if (bedrooms[index].length > 1) {
                var room = new Array();
                var exclude_items = new Array();

                for (var index2 in bedrooms[index]) {
                    if (
                        bedrooms[index][index2] != "BEDROOM" &&
                        (exclude_items.length < 1 ||
                            !exclude_items.includes(bedrooms[index][index2]))
                    ) {
                        var parts = bedrooms[index][index2].split("_");
                        var count = bedrooms[index].filter(
                            (v) => v === bedrooms[index][index2]
                        ).length;
                        if (count > 1) {
                            exclude_items.push(bedrooms[index][index2]);
                            room.push(
                                parts[1].toLowerCase() +
                                " " +
                                parts[0].toLowerCase() +
                                "(" +
                                count +
                                "x)"
                            );
                        } else {
                            room.push(
                                parts[1].toLowerCase() + " " + parts[0].toLowerCase()
                            );
                        }
                    }
                }
                returnArray.push(room.join(" and "));
            }
        }
        return returnArray.join(", ");
    },
    getLocaleRoomName(room, locale) {
        if (room.texts) {
            if (JSON.parse(room.texts).displayName[locale.toUpperCase()]) {
                return JSON.parse(room.texts).displayName[locale.toUpperCase()]
            } else if (JSON.parse(room.texts).displayName["EN"]) {
                return JSON.parse(room.texts).displayName["EN"]
            } else {
                return room.name
            }
        } else {
            return room.name
        }
    },
    colorChannelMixer(colorChannelA, colorChannelB, amountToMix) {
        var channelA = colorChannelA * amountToMix;
        var channelB = colorChannelB * (1 - amountToMix);
        return parseInt(channelA + channelB);
    },
    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    },
    getDarkerColor() {
        var rgbA = this.hexToRgb(JSON.parse(this.client)['main_color']);
        var rgbB = [17, 24, 39];

        var r = this.colorChannelMixer(rgbA['r'], rgbB[0], 0.5);
        var g = this.colorChannelMixer(rgbA['g'], rgbB[1], 0.5);
        var b = this.colorChannelMixer(rgbA['b'], rgbB[2], 0.5);

        return 'rgb('+r+','+g+','+b+')';
    },
    changeTheme() {
        if (this.modalfocus) {
            document.querySelector('meta[name="theme-color"]').setAttribute("content", JSON.parse(this.client)['main_color']);
        } else {

            
            document.querySelector('meta[name="theme-color"]').setAttribute("content", this.darkerColor);
        }
        this.modalfocus = !this.modalfocus
    }
}

export default roomhelpers
